import * as z from 'zod';

export const serviceFeeSchema = z.object({
  rate_pct: z.number().finite().min(0).max(100),
  min_fee: z.number().finite().min(0),
  max_fee: z.number().finite().min(0),
  min_order_amount: z.number().finite().min(0),
  low_order_fee: z.number().finite().min(0),
});

export type ServiceFeeSettings = z.infer<typeof serviceFeeSchema>;

export const serviceFeeFormSchema = serviceFeeSchema.superRefine((value, ctx) => {
  if (value.max_fee < value.min_fee) {
    ctx.addIssue({
      code: 'custom',
      path: ['max_fee'],
      message: 'serviceFee.errors.maxFee',
    });
  }
});

export type ServiceFeeFormValues = z.infer<typeof serviceFeeFormSchema>;
